import React, { Component } from 'react';
import Table from '../../../../components/_table/Table/Table';
import Panel from '../../../../components/outline/Panel';
import Button from '../../../../components/Button';
import { comparePrePropsAndNextProps, asyncSimpleModal } from '../../../../lib/common';
import { columns } from './columns';
import './SearchWordList.scss';

class SearchWordList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const { searchWordList, initialOption, sortOption, pagination, getList, getSearchWordListExcelDownload } =
      this.props;

    return (
      <Panel className="search-word-list">
        <div className="panel-header">
          <div className="title">검색 키워드 리스트</div>

          <Button
            isRadius
            color="primary"
            text="엑셀 다운"
            onClick={async () => {
              const confirmResult = await asyncSimpleModal({
                type: 'confirm',
                title: '엑셀 다운로드',
                message: '최대 10,000개까지 엑셀 다운로드 됩니다.',
              });

              if (!confirmResult) return;

              getSearchWordListExcelDownload();
            }}
          />
        </div>

        <div className="panel-body">
          <Table
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
            rowKey={(record) => record.id}
            initialOption={initialOption}
            sortOption={sortOption}
            pagination={pagination}
            list={searchWordList}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    );
  }
}

export default SearchWordList;
